module.exports = __webpack_public_path__ + "img/gaoxiaoshisheng.984f4f66.png";